import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Box } from '../utility/layout.mjs';
import { useEmptyContext } from './context.mjs';
import { title } from './empty.vanilla.mjs';

const Title = forwardRef(
  ({ children, className, ...props }, forwardedRef) => {
    const { size } = useEmptyContext("Empty.Title");
    return /* @__PURE__ */ jsx(
      TitleStyleImpl,
      {
        ...props,
        className: classNames(title({ size }), className),
        ref: forwardedRef,
        children
      }
    );
  }
);
const TitleStyleImpl = styled(Box);

export { Title as default };
//# sourceMappingURL=Title.mjs.map
